const P = "/images/projects";

export const FILTER_OPTIONS = [
  "All",
  "Dubai",
  "Abu Dhabi",
  "Ras Al Khaimah & Al Marjan Island",
  "Branded Residences",
  "Waterfront / Beachfront",
  "Commercial",
  "Family / Second Home",
  "Investment-led Payment Plan",
];

export const opportunities = [
  {
    slug: "bugatti-residences-by-binghatti",
    name: "Bugatti Residences by Binghatti",
    developer: "Binghatti",
    location: "Business Bay, Dubai",
    emirate: "Dubai",
    categories: ["Dubai", "Branded Residences"],
    type: "Branded luxury residences",
    price: "On Request",
    badge: "Branded Residence",
    tagline: "The French marque's first residential address, rising above the Business Bay canal.",
    description: [
      "Bugatti Residences by Binghatti brings one of the world's most recognisable luxury marques to the Dubai skyline. Set in Business Bay, minutes from Downtown and the Dubai Canal, the tower pairs sculptural architecture with interiors inspired by the Bugatti design language — including the Riviera-inspired beach and signature car lifts that carry vehicles directly to the Sky Mansion penthouses.",
      "For overseas buyers, it represents the branded-residence thesis in its purest form: a globally recognisable name, a tightly limited collection of 171 Riviera Mansions and 11 Sky Mansion penthouses, and a location at the centre of Dubai's strongest rental and resale corridor.",
    ],
    highlights: ["Branded residence by a global luxury marque", "Business Bay canal-side position", "Riviera-inspired beach and private pools", "Signature car lifts to Sky Mansion penthouses"],
    image: `${P}/bugatti-1.jpg`,
  },
  {
    slug: "taj-wellington-mews",
    name: "Taj Wellington Mews",
    developer: "Taj / BNW Developments",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Branded Residences", "Waterfront / Beachfront"],
    type: "Branded island living",
    price: "On Request",
    badge: "Island Living",
    tagline: "Taj-branded hospitality meets freehold island ownership on Al Marjan.",
    description: [
      "Taj Wellington Mews brings the Indian Hotels Company's celebrated Taj brand to Al Marjan Island — the brand's first branded residences in the UAE. Two interconnected towers house 336 one- to three-bedroom hotel apartments, minutes from the Wynn resort.",
      "For lifestyle-led buyers, it pairs hotel-grade 'Tajness' service with the flexibility of private freehold ownership on one of the UAE's most closely watched growth islands.",
    ],
    highlights: ["Taj-branded serviced residences", "Freehold ownership on Al Marjan Island", "Beachfront setting with resort amenities", "Positioned within the Al Marjan growth corridor"],
    image: `${P}/taj-1.jpg`,
  },
  {
    slug: "lumena-by-omniyat",
    name: "LUMENA by OMNIYAT",
    developer: "OMNIYAT",
    location: "Business Bay, Dubai",
    emirate: "Dubai",
    categories: ["Dubai", "Commercial"],
    type: "Premium commercial address",
    price: "On Request",
    badge: "Commercial",
    tagline: "A rare ultra-premium commercial address from Dubai's design-led developer.",
    description: [
      "LUMENA is OMNIYAT's statement commercial tower at the gateway of Business Bay — a 260-metre sculpted landmark with views of the Burj Khalifa and the Gulf, targeting LEED Platinum, WiredScore and SmartScore Platinum pre-certifications.",
      "For investors, premium commercial stock in Dubai's central corridor offers a different return profile to residential: corporate covenants, longer leases and exposure to the emirate's growing base of regional headquarters.",
    ],
    highlights: ["OMNIYAT design pedigree", "Direct Business Bay Metro connectivity", "Sky gardens, Sky Theatre and executive club", "Corporate tenant demand corridor"],
    image: `${P}/lumena-1.jpg`,
  },
  {
    slug: "residences-at-sheraton-al-marjan",
    name: "Sheraton Residences",
    developer: "Sheraton / Atara Development",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Branded Residences", "Waterfront / Beachfront"],
    type: "Beachfront residences",
    price: "On Request",
    badge: "Beachfront",
    tagline: "Resort-managed beachfront homes within a fully operational island resort.",
    description: [
      "The Residences at Sheraton Al Marjan Island Resort are the first Sheraton-branded residences in the GCC — 168 hotel-serviced homes (97 one-beds, 71 two-beds) co-located with the operating resort, with private beach access, a wellness hub and rooftop infinity pool.",
      "For lifestyle-led buyers, the appeal is immediate: a turnkey beach address that can be enjoyed personally and placed into a professionally managed rental programme when not in use.",
    ],
    highlights: ["First Sheraton-branded residences in the GCC", "Direct private beach access", "Managed rental programme potential", "Marriott Bonvoy ownership privileges"],
    image: `${P}/sheraton-1.jpg`,
  },
  {
    slug: "the-oasis-by-emaar",
    name: "The Oasis by Emaar",
    developer: "Emaar Properties",
    location: "Dubai",
    emirate: "Dubai",
    categories: ["Dubai", "Family / Second Home", "Investment-led Payment Plan"],
    type: "Luxury villa and mansion community",
    price: "On Request",
    badge: "Villa Community",
    tagline: "Emaar's resort-style villa and mansion community built around crystal lagoons.",
    description: [
      "The Oasis by Emaar — known to many buyers as Emaar The Oasis or simply Emaar Oasis — is a landmark 100-million-sq ft masterplan of mansions and villas arranged around swimmable lagoons, canals and parkland. The Oasis Dubai community is designed as a resort you live in, rather than a suburb you commute from, and sets a new benchmark for Dubai luxury villas.",
      "Emaar's community track record, from Emirates Hills to Dubai Hills, underpins the investment case: family demand, limited villa supply and a developer with a long history of delivered masterplans.",
    ],
    seoTitle: "The Oasis by Emaar Dubai | Villas & Mansions | ACRE",
    h1: "The Oasis by Emaar, Dubai",
    metaDescription: "Explore The Oasis by Emaar in Dubai, a luxury villa and mansion community with waterfront landscapes, premium homes and curated opportunities through ACRE.",
    highlights: ["Emaar master developer", "Lagoon-centred villa community", "Villas and mansions with generous plots", "Family-first amenity planning"],
    image: `${P}/oasis-1.jpg`,
  },
  {
    slug: "miraggio-by-source-of-fate",
    name: "Miraggio by Source of Fate",
    developer: "Source of Fate",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Waterfront / Beachfront", "Investment-led Payment Plan"],
    type: "Island residences",
    price: "On Request",
    badge: "New Launch",
    tagline: "Wave-inspired architecture on Al Marjan's only gated beachfront plot.",
    description: [
      "Miraggio by Source of Fate is a wave-inspired development on the central islet of Al Marjan Island, near the Wynn resort. Residences range from studios to three-bedroom apartments, with a private beach and infinity pool over the Gulf.",
      "For buyers entering the Al Marjan story, Miraggio offers a design-led entry point into the island's growth curve with a payment plan extending two years beyond handover. The verified launch figures and their sources are shown below.",
    ],
    highlights: ["Gated beachfront plot, central islet", "Wave-inspired architecture", "Private beach and Gulf-facing infinity pool", "Post-handover payment structure"],
    image: `${P}/miraggio-1.jpg`,
  },
  {
    slug: "mercedes-benz-places-by-binghatti",
    name: "Mercedes-Benz Places by Binghatti",
    developer: "Binghatti",
    location: "Downtown Dubai",
    emirate: "Dubai",
    categories: ["Dubai", "Branded Residences"],
    type: "Branded luxury residences",
    price: "On Request",
    badge: "Branded Residence",
    tagline: "The Mercedes-Benz design philosophy translated into a Downtown Dubai landmark.",
    description: [
      "Mercedes-Benz Places brings the automotive brand's philosophy of Sensual Purity to a 65-storey residential tower in the Downtown district — elliptical architecture, branded interiors and a service standard aligned to the marque's global identity.",
      "Downtown Dubai remains the emirate's most liquid residential market — a consideration that matters to overseas buyers thinking about eventual exit as much as entry.",
    ],
    highlights: ["Mercedes-Benz branded interiors", "Downtown Dubai address", "High-liquidity resale market", "Full concierge and lifestyle services"],
    image: `${P}/mercedes-1.jpg`,
  },
  {
    slug: "nakheel-palm-collection",
    name: "Nakheel Palm Collection",
    developer: "Nakheel",
    location: "Palm Jumeirah / Palm Jebel Ali, Dubai",
    emirate: "Dubai",
    categories: ["Dubai", "Waterfront / Beachfront", "Family / Second Home"],
    type: "Palm villas and residences",
    price: "On Request",
    badge: "Palm Address",
    tagline: "Villas and residences across Dubai's most famous island — and its emerging sister Palm.",
    description: [
      "Nakheel's Palm Collection spans the original Palm Jumeirah — the address that defined Dubai luxury — and the reborn Palm Jebel Ali, where the Beach and Coral villa collections offer five-to-seven-bedroom beachfront homes by architects including SAOTA and WATG.",
      "Palm Jumeirah villas for sale remain among the most searched and most resilient assets in the emirate, combining scarcity, global recognition and genuine waterfront living.",
    ],
    highlights: ["Palm Jumeirah and Palm Jebel Ali addresses", "Beach and Coral villa collections", "Master developer: Nakheel", "Globally recognised island asset class"],
    image: `${P}/nakheel-1.jpg`,
  },
  {
    slug: "orla-dorchester-collection",
    name: "ORLA, Dorchester Collection",
    developer: "OMNIYAT",
    location: "Palm Jumeirah, Dubai",
    emirate: "Dubai",
    categories: ["Dubai", "Branded Residences", "Waterfront / Beachfront"],
    type: "Ultra-luxury branded residences",
    price: "On Request",
    badge: "Ultra-Luxury",
    tagline: "OMNIYAT's crescent-edge masterpiece, managed by Dorchester Collection.",
    description: [
      "ORLA occupies one of the final prime plots on the Palm Jumeirah crescent — a Foster + Partners-designed collection of vast residences, sky palaces and mansions managed by Dorchester Collection, with a residents-only beach club along 150 metres of private sand.",
      "ORLA sits at the very top of Dubai's residential market. For buyers at this level, the considerations are privacy, service, architecture and the long-term value of genuinely irreplaceable positions.",
    ],
    highlights: ["Managed by Dorchester Collection", "Palm Jumeirah crescent position", "Foster + Partners architecture", "Extremely limited collection"],
    image: `${P}/orla-1.jpg`,
  },
  {
    slug: "palazzo-tissoli",
    name: "Palazzo Tissoli",
    developer: "Tissoli",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Waterfront / Beachfront", "Investment-led Payment Plan"],
    type: "Boutique island residences",
    price: "On Request",
    badge: "Boutique",
    tagline: "A Pininfarina-designed palazzo on the shores of Al Marjan Island.",
    description: [
      "Palazzo Tissoli is the first Pininfarina-designed residential project in Ras Al Khaimah — furnished studios and one-bedroom residences with concierge, spa, pools and co-working, minutes from the Wynn resort, wrapped in classical Italian proportions.",
      "Boutique projects on the island appeal to buyers who want the Al Marjan growth story without the scale of the major resorts: quieter lobbies, fewer neighbours, and characterful architecture.",
    ],
    highlights: ["Pininfarina architecture and design", "Al Marjan Island shoreline", "Lifestyle amenities", "Fully furnished residences"],
    image: `${P}/tissoli-1.jpg`,
  },
  {
    slug: "sobha-hartland-ii",
    name: "Sobha Hartland II",
    developer: "Sobha Realty",
    location: "MBR City, Dubai",
    emirate: "Dubai",
    categories: ["Dubai", "Family / Second Home", "Investment-led Payment Plan"],
    type: "Waterfront community living",
    price: "On Request",
    badge: "Community",
    tagline: "Sobha's forest-and-lagoon community minutes from Downtown Dubai.",
    description: [
      "Sobha Hartland II is an 8-million-sq ft waterfront community pairing villas, mansions and apartments with twin blue lagoons, boardwalks and over a million sq ft of green space — all within roughly fifteen minutes of Downtown.",
      "Sobha's vertically integrated build quality and a maturing community around it make Hartland II a consistent choice for families and second-home buyers who want space without leaving the city.",
    ],
    highlights: ["Sobha build quality", "Twin lagoon and forest masterplan", "Close to Downtown Dubai", "Villas, mansions and apartments"],
    image: `${P}/sobha-1.jpg`,
  },
  {
    slug: "cavalli-by-damac",
    name: "DAMAC Bay by Cavalli",
    developer: "DAMAC Properties",
    location: "Dubai Harbour",
    emirate: "Dubai",
    categories: ["Dubai", "Branded Residences", "Waterfront / Beachfront"],
    type: "Fashion-branded seafront residences",
    price: "On Request",
    badge: "Seafront",
    tagline: "Roberto Cavalli-branded seafront living at the gateway to Dubai Harbour.",
    description: [
      "DAMAC Bay by Cavalli brings the Italian fashion house's flamboyant aesthetic to three interconnected seafront towers at Dubai Harbour, with private beach access, floating pools and nautical-inspired interiors styled by Cavalli.",
      "Dubai Harbour is one of the city's newest waterfront districts — home to the region's largest marina and a growing cruise terminal — giving the address a genuine maritime character.",
    ],
    highlights: ["Roberto Cavalli branded interiors", "Dubai Harbour seafront position", "Private beach and resort amenities", "Triple-tower design with sky bridges"],
    image: `${P}/damac-1.jpg`,
  },
];

export const developments = [
  ...opportunities,
  {
    slug: "aqua-maya",
    name: "Aqua Maya",
    developer: "BNW Developments",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Waterfront / Beachfront", "Investment-led Payment Plan"],
    type: "Island residences",
    price: "On Request",
    badge: "Island Living",
    tagline: "Contemporary waterfront residences on Al Marjan Island's shoreline.",
    description: ["Aqua Maya is BNW's compact, family-oriented island residence — 99 homes, mostly one- and two-beds, with pool, children's play areas and gym — with developer-published entry from AED 1.78m (checked 1 October 2026)."],
    highlights: ["Al Marjan Island shoreline", "Sea-view residences", "Resort district setting"],
    image: `${P}/aquamaya-1.jpg`,
  },
  {
    slug: "aqua-arc",
    name: "Aqua Arc",
    developer: "BNW Developments",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Waterfront / Beachfront"],
    type: "Island residences",
    price: "On Request",
    badge: "Island Living",
    tagline: "Sculpted architecture and panoramic Gulf views on Al Marjan Island.",
    description: ["Aqua Arc is BNW's sculptural twin-tower residence on Al Marjan Island, mixing one- to three-bedroom apartments, townhouses and penthouses around panoramic Gulf views. The verified launch prices, payment structure and handover target are shown below, with availability confirmed on enquiry."],
    seoTitle: "Aqua Arc Al Marjan Island | Ras Al Khaimah Property | ACRE",
    h1: "Aqua Arc, Al Marjan Island",
    metaDescription: "Explore Aqua Arc on Al Marjan Island, Ras Al Khaimah. Discover the development, location, lifestyle, ownership proposition and current availability through ACRE.",
    highlights: ["Panoramic Gulf views", "Design-led architecture", "Al Marjan Island address"],
    image: `${P}/aquaarc-1.jpg`,
  },
  {
    slug: "fashiontv-acacia",
    name: "FashionTV Acacia",
    developer: "FashionTV / BNW",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Branded Residences", "Investment-led Payment Plan"],
    type: "Fashion-branded residences",
    price: "On Request",
    badge: "Branded Residence",
    tagline: "FashionTV-branded island living with a strong lifestyle identity.",
    description: ["FashionTV Acacia brings the global fashion broadcaster's brand to branded residences on Al Marjan Island — bold interiors, lifestyle programming and resort access."],
    highlights: ["FashionTV branding", "Lifestyle-led amenity programming", "Al Marjan Island setting"],
    image: `${P}/fashiontv-1.jpg`,
  },
  {
    slug: "radisson-blu-rak-central",
    name: "Radisson Blu Residences",
    developer: "BNW / Radisson Hotel Group",
    location: "RAK Central, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Branded Residences", "Commercial"],
    type: "Branded city residences",
    price: "On Request",
    badge: "Branded Residence",
    tagline: "Hotel-branded residences in Ras Al Khaimah's new central business district.",
    description: ["Radisson Blu Residences at RAK Central bring hotel-branded homes to the emirate's emerging downtown, alongside a Radisson Blu hotel and hotel-delivered services."],
    highlights: ["Radisson Blu brand", "RAK Central business district", "Hotel-delivered services"],
    image: `${P}/radisson-1.jpg`,
  },
  {
    slug: "jw-marriott-residences-al-marjan",
    name: "JW Marriott Residences",
    developer: "WOW Resorts / Marriott International",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Branded Residences", "Waterfront / Beachfront"],
    type: "Luxury branded residences",
    price: "On Request",
    badge: "Branded Residence",
    tagline: "JW Marriott's signature service applied to beachfront island homes.",
    description: ["JW Marriott Residences by WOW Resorts bring the brand's polished service culture to Al Marjan Island — one- to four-bedroom beachfront residences and signature penthouses, co-located with the JW Marriott resort, its seven dining venues, spa and private lagoon."],
    highlights: ["JW Marriott service standard", "Beachfront island position", "Full resort facility access"],
    image: `${P}/jw-2.jpg`,
  },
  {
    slug: "w-residences-al-marjan",
    name: "W Residences",
    developer: "Dalands Holding / Marriott International",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Branded Residences", "Waterfront / Beachfront"],
    type: "Lifestyle branded residences",
    price: "On Request",
    badge: "Branded Residence",
    tagline: "The W lifestyle — bold, social and design-driven — on Al Marjan's beachfront.",
    description: ["W Residences translate the W Hotels lifestyle into 201 fully furnished private homes: the WET infinity deck, FIT hub, residents' lounge and a 130-metre beachfront, co-located with the W Al Marjan Island hotel."],
    highlights: ["W Hotels lifestyle brand", "130-metre beachfront", "Design-driven interiors"],
    image: `${P}/w-res-1.jpg`,
  },
  {
    slug: "janu-al-marjan-island",
    name: "Janu Residences",
    developer: "Marjan",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Branded Residences", "Waterfront / Beachfront"],
    type: "Wellness branded residences",
    price: "On Request",
    badge: "Ultra-Luxury",
    tagline: "Aman Group's wellness-focused Janu brand arrives in the UAE on Al Marjan.",
    description: ["Janu — Aman Group's wellness-led sibling brand — is being brought to Al Marjan Island by Marjan, combining wellbeing programming, SCDA-designed architecture and beachfront calm adjacent to the Wynn resort."],
    highlights: ["Aman Group pedigree", "Wellness-led living", "SCDA Architects design"],
    image: `${P}/janu-1.jpg`,
  },
  {
    slug: "tonino-lamborghini-residences-al-marjan",
    name: "Tonino Lamborghini Residences",
    developer: "BNW / Tonino Lamborghini",
    location: "Al Marjan Island, Ras Al Khaimah",
    emirate: "Ras Al Khaimah",
    categories: ["Ras Al Khaimah & Al Marjan Island", "Branded Residences"],
    type: "Italian branded residences",
    price: "On Request",
    badge: "Branded Residence",
    tagline: "Italian design heritage meets island beachfront living.",
    description: ["Tonino Lamborghini Residences carry the Italian marque's design language — bold lines, crafted materials — into a 373-residence collection of studios, apartments, penthouses, villas and mansions on Al Marjan Island."],
    highlights: ["Italian luxury branding", "Apartments to mansions", "Design-led interiors"],
    image: `${P}/tonino-1.jpg`,
  },
  {
    slug: "yas-island-collection",
    name: "Yas Island Collection",
    developer: "Aldar Properties",
    location: "Yas Island, Abu Dhabi",
    emirate: "Abu Dhabi",
    categories: ["Abu Dhabi", "Family / Second Home", "Investment-led Payment Plan"],
    type: "Entertainment district living",
    price: "On Request",
    badge: "Family Lifestyle",
    tagline: "Apartments and townhouses at the heart of Abu Dhabi's entertainment island.",
    description: ["The Yas Island Collection places residents at the centre of Abu Dhabi's leisure district — Ferrari World, Yas Marina Circuit, Yas Mall and the waterfront all minutes away."],
    highlights: ["Yas Island entertainment district", "Aldar master development", "Family-oriented amenities"],
    image: `${P}/yasisland-1.jpg`,
  },
  {
    slug: "yas-golf-collection-by-aldar",
    name: "Yas Golf Collection by Aldar",
    developer: "Aldar Properties",
    location: "Yas Island, Abu Dhabi",
    emirate: "Abu Dhabi",
    categories: ["Abu Dhabi", "Family / Second Home"],
    type: "Golf-front residences",
    price: "On Request",
    badge: "Golf Living",
    tagline: "Fairway-facing apartments overlooking Yas Links golf course.",
    description: ["The Yas Golf Collection offers fairway-facing living beside Yas Links — one of the region's most celebrated courses — within a mature, family-friendly island community of over a thousand residences."],
    highlights: ["Yas Links golf views", "Established island community", "Aldar build quality"],
    image: `${P}/yasgolf-1.jpg`,
  },
  {
    slug: "saadiyat-lagoons-by-aldar",
    name: "Saadiyat Lagoons by Aldar",
    developer: "Aldar Properties",
    location: "Saadiyat Island, Abu Dhabi",
    emirate: "Abu Dhabi",
    categories: ["Abu Dhabi", "Family / Second Home", "Waterfront / Beachfront"],
    type: "Lagoon villa community",
    price: "On Request",
    badge: "Villa Community",
    tagline: "Mangrove-side villas on Abu Dhabi's cultural island.",
    description: ["Saadiyat Lagoons places villa living between protected mangroves and the cultural district of Saadiyat Island — home to the Louvre Abu Dhabi and some of the UAE's finest beaches."],
    highlights: ["Saadiyat Island cultural district", "Mangrove and lagoon setting", "Villa community by Aldar"],
    image: `${P}/lagoons-1.jpg`,
  },
  {
    slug: "mamsha-al-saadiyat",
    name: "Mamsha Al Saadiyat",
    developer: "Aldar Properties",
    location: "Saadiyat Island, Abu Dhabi",
    emirate: "Abu Dhabi",
    categories: ["Abu Dhabi", "Waterfront / Beachfront", "Family / Second Home"],
    type: "Beachfront promenade living",
    price: "On Request",
    badge: "Beachfront",
    tagline: "Beachfront promenade apartments on Saadiyat's white-sand shoreline.",
    description: ["Mamsha Al Saadiyat is a beachfront promenade community on Saadiyat Island — apartments, penthouses and townhouses steps from one of the UAE's most beautiful natural beaches and the cultural district."],
    highlights: ["Direct beach access", "Saadiyat cultural district", "Promenade dining and retail"],
    image: `${P}/mamsha-1.jpg`,
  },
];

export const rakProjectFacts = {
  "taj-wellington-mews": [
    { label: "Unit mix", value: "336 one- to three-bedroom hotel apartments", source: "BNW project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 1.5m", source: "Developer-published entry price, checked 1 October 2026" },
    { label: "Payment plan", value: "10% booking + 50% before completion + 40% on completion", source: "Developer-published schedule; subject to the reservation agreement and SPA" },
    { label: "Handover", value: "Q1 2028", source: "Developer-published target, checked 1 October 2026" },
  ],
  "residences-at-sheraton-al-marjan": [
    { label: "Unit mix", value: "168 hotel-serviced residences: 97 one-beds and 71 two-beds", source: "Atara project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 2.2m", source: "Developer-published entry price, checked 1 October 2026" },
    { label: "Payment plan", value: "On request", source: "Atara's published page is internally inconsistent; written schedule required" },
    { label: "Handover", value: "Q3 2028", source: "Developer-published target, checked 1 October 2026" },
  ],
  "miraggio-by-source-of-fate": [
    { label: "Unit mix", value: "Studios to three-bedroom apartments", source: "Source of Fate project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 1.2m", source: "Property Finder launch asking price, accessed 1 October 2026; developer price not published" },
    { label: "Payment plan", value: "5% booking + 5% on SPA + 5% in month 3 + 5% in month 6 + 40% on completion + 40% over two years post-handover", source: "Developer-linked launch schedule, checked 1 October 2026; confirm in the SPA" },
    { label: "Handover", value: "Q4 2028 (portal target)", source: "Portal-sourced target, accessed 1 October 2026; developer date not published" },
  ],
  "palazzo-tissoli": [
    { label: "Unit mix", value: "Furnished studios and one-bedroom residences", source: "Tissoli project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 1.1m", source: "dubizzle launch asking price, accessed 1 October 2026; developer price not published" },
    { label: "Payment plan", value: "5% down + 45% before handover across five payments + 50% on handover", source: "Portal launch schedule, accessed 1 October 2026; developer plan not published" },
    { label: "Handover", value: "On request", source: "Official developer date not published; third-party sources conflict between Q1 and Q2 2028" },
  ],
  "aqua-maya": [
    { label: "Unit mix", value: "99 residences, mostly one- and two-bedroom homes", source: "BNW project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 1.78m; two-beds from AED 2.75m", source: "Developer-published entry prices, checked 1 October 2026" },
    { label: "Payment plan", value: "10% booking + eight 5% instalments + 50% on completion", source: "Developer-published schedule; subject to the reservation agreement and SPA" },
    { label: "Handover", value: "Q4 2027", source: "Developer-published target, checked 1 October 2026" },
  ],
  "aqua-arc": [
    { label: "Unit mix", value: "226 residences: one- to three-bed apartments, townhouses and penthouses", source: "BNW project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 2.3m", source: "Developer-published entry price, checked 1 October 2026" },
    { label: "Payment plan", value: "10% booking + 40% during construction + 50% on completion", source: "Developer-published schedule; subject to the reservation agreement and SPA" },
    { label: "Handover", value: "Q3 2027", source: "Developer-published target, checked 1 October 2026" },
  ],
  "jw-marriott-residences-al-marjan": [
    { label: "Unit mix", value: "One- to four-bedroom residences and penthouses alongside seven resort dining venues", source: "WOW Resorts project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 3.1m", source: "Property Finder launch asking price, accessed 1 October 2026; developer price not published" },
    { label: "Payment plan", value: "10% launch + 60% during construction in eight instalments + 30% on handover", source: "Portal launch schedule, accessed 1 October 2026; developer schedule not published" },
    { label: "Handover", value: "December 2027 (portal target)", source: "Portal-sourced target, accessed 1 October 2026; developer date not published" },
  ],
  "w-residences-al-marjan": [
    { label: "Unit mix", value: "201 fully furnished residences on a 130-metre beachfront", source: "Dalands project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 4.1m", source: "Property Finder launch asking price, accessed 1 October 2026; Dalands starting price not published" },
    { label: "Payment plan", value: "70% during construction + 30% on handover", source: "Portal launch schedule, accessed 1 October 2026; developer schedule not published" },
    { label: "Handover", value: "Q4 2027", source: "Dalands developer-published target, checked 1 October 2026; conflicting portal date is not primary" },
  ],
  "fashiontv-acacia": [
    { label: "Unit mix", value: "182 one-bed, 23 two-bed and 19 three-bed apartments, plus 4 four-bedroom penthouses", source: "BNW project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 1.96m", source: "BNW-published entry price, checked 1 October 2026" },
    { label: "Payment plan", value: "From 10% down; full schedule on request", source: "BNW project materials, checked 1 October 2026; confirm in the SPA" },
    { label: "Handover", value: "Q2 2028", source: "BNW-published target, checked 1 October 2026" },
  ],
  "radisson-blu-rak-central": [
    { label: "Unit mix", value: "222 branded residences adjacent to a 361-key Radisson Blu hotel", source: "BNW project announcement, checked 1 October 2026" },
    { label: "Starting price", value: "On request", source: "Current developer price not published, checked 1 October 2026" },
    { label: "Payment plan", value: "On request", source: "Current developer schedule not published, checked 1 October 2026" },
    { label: "Handover", value: "2029 target", source: "BNW project announcement, checked 1 October 2026" },
  ],
  "janu-al-marjan-island": [
    { label: "Unit mix", value: "One- to five-bedroom residences and five standalone villas", source: "Janu and Marjan project materials, checked 1 October 2026" },
    { label: "Starting price", value: "On request", source: "Current developer price not published, checked 1 October 2026" },
    { label: "Payment plan", value: "On request", source: "Current developer schedule not published, checked 1 October 2026" },
    { label: "Handover", value: "2029 target", source: "Marjan project announcement, checked 1 October 2026" },
  ],
  "tonino-lamborghini-residences-al-marjan": [
    { label: "Unit mix", value: "373 homes: studios to penthouses, villas and mansions", source: "BNW project materials, checked 1 October 2026" },
    { label: "Starting price", value: "From AED 1.69m", source: "Developer-published entry price, checked 1 October 2026" },
    { label: "Payment plan", value: "10% booking + 10% within 30 days + ten 5% instalments + 30% on completion", source: "Developer-published schedule; subject to the reservation agreement and SPA" },
    { label: "Handover", value: "Q4 2028", source: "Developer-published target, checked 1 October 2026" },
  ],
};

export const allProjects = developments;
